import { render, staticRenderFns } from "./NewtonButton.vue?vue&type=template&id=5f69312a&scoped=true"
import script from "./NewtonButton.vue?vue&type=script&lang=js"
export * from "./NewtonButton.vue?vue&type=script&lang=js"
import style0 from "./NewtonButton.vue?vue&type=style&index=0&id=5f69312a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f69312a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
